import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

type UpdateBookingStatusParams = {
  booking_id: string;
  status: 'accepted' | 'declined' | 'completed';
  decline_reason?: string;
};

const useUpdateBookingStatus = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (params: UpdateBookingStatusParams) => {
    const { data, error } = await supabaseClient.functions.invoke('update_booking_status', {
      method: 'POST',
      body: params,
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      // Invalidate bookings query to refetch
      queryClient.invalidateQueries({ queryKey: ['bookingRequests'] });
    },
  });
};

export default useUpdateBookingStatus;
